import React, {Suspense } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter} from "react-router";
import "react-toastify/dist/ReactToastify.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./assets/vendor/fullcalendar/dist/fullcalendar.min.css";
import "./assets/vendor/sweetalert2/dist/sweetalert2.min.css";
import "./assets/vendor/select2/dist/css/select2.min.css";
import "./assets/vendor/quill/dist/quill.core.css";
import "./assets/vendor/nucleo/css/nucleo.css";
// (SCRUM-658) dropped the functionless `?v1.0.0` query suffix — webpack ignored
// it, Vite would treat it as an unknown import query.
import "./assets/scss/argon-dashboard-pro-react.scss";
import "./assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
import { Provider } from "react-redux";
import store from "./services/store";
import AppRouter from './App';
import { initSiteConfig } from './utils/config';
import { registerGlobalRejectionNet } from "./services/globalRejectionNet";
import SiteUnreachableNotice from "./components/SiteUnreachableNotice";

async function boot() {
  const siteResolved = await initSiteConfig();

  // SCRUM-840 Part 3: surface silent read failures (fetch-and-forget thunks with
  // no .catch) through the same GET_ERRORS hub instead of an unhandled rejection.
  registerGlobalRejectionNet(store);

  const rootElement = document.getElementById('root');
  // index.html always carries #root; createRoot(null) would throw anyway, this
  // names the cause and narrows the type for the reads below.
  if (!rootElement) throw new Error("#root element missing");
  const root = createRoot(rootElement);

  // SCRUM-2384: without a resolved site every request would carry the dev
  // fallback id, so nothing of the app is mounted.
  if (!siteResolved) {
    root.render(<SiteUnreachableNotice />);
    return;
  }

  const renderApp = (
    // React.StrictMode surfaces effect-order / cleanup bugs by double-invoking
    // effects (and re-running renders) in development — the class of race the
    // notification-hub work hardened against. Dev-only; production is unaffected.
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <Suspense fallback={<div>Loading ...</div>}>
            <AppRouter />
          </Suspense>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );

  if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, renderApp);
  } else {
    root.render(renderApp);
  }
}

boot();